import React from "react";
import { Link } from "react-router-dom";
import { STORE } from "../config/store";
import { policyGroups } from "../config/policyNavigation";
import "../css/footer.scss";

function Footer() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-top">
        <div className="footer-column">
          <h3>Shop & Help</h3>
          <ul>
            <li><Link to="/shop" onClick={toTop}>Shop</Link></li>
            <li><Link to="/about" onClick={toTop}>About {STORE.brand}</Link></li>
            <li><Link to="/contact" onClick={toTop}>Contact</Link></li>
            <li><Link to="/faq" onClick={toTop}>FAQ</Link></li>
          </ul>
        </div>
        <div className="footer-column policy-directory">
          <h3><Link to="/policies" onClick={toTop}>Policies</Link></h3>
          <div className="footer-policy-groups">
            {policyGroups.map((group) => (
              <section key={group.label}>
                <h4>{group.label}</h4>
                <ul>{group.links.map(([label, to]) => <li key={to}><Link to={to} onClick={toTop}>{label}</Link></li>)}</ul>
              </section>
            ))}
          </div>
        </div>
        <div className="footer-column store-details">
          <h3>{STORE.brand}</h3>
          <p>Operating region: {STORE.operatingRegion}</p>
          <p>Currency: {STORE.currency}</p>
          {STORE.address && <p>{STORE.address}</p>}
          <a href={`mailto:${STORE.supportEmail}`}>{STORE.supportEmail}</a>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="copyright">&copy; 2026 {STORE.brand}. All rights reserved.</div>
        <div className="payment-method" aria-label="Supported payment method: card through secure hosted checkout">
          <svg viewBox="0 0 42 28" aria-hidden="true"><rect x="1" y="1" width="40" height="26" rx="4"/><path d="M1 8h40M7 20h9" /></svg>
          <span>Secure hosted card checkout</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
